module.exports = __webpack_public_path__ + "img/Warehouse01E.2e840438.jpg";